



































































































































































































































































































































































































































































































































































































































































































































































import { Vue, Component, Emit } from "vue-property-decorator";

import usuarioModule from "@/store/usuario/UsuarioModule";
import { usuarioStorage } from "@/store/usuario/UsuarioStorage";
import { Authoritie } from "@/models/administracao/usuario/GrupoModel";

@Component({
  components: {}
})
export default class SideNav extends Vue {
  isSideBarActive = true;
  activeDropdowns: string[] = [];

  mounted() {
    this.$emit("sideBarActive", this.isSideBarActive);
  }

  @Emit("navigate")
  navigate(route: any) {}

  logout() {
    usuarioModule
      .logout()
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        try {
          // console.log(this.$router);
          this.$router.push({ name: "Login" }).catch((err) => {
            console.log(err);
          });
        } catch (err) {
          console.error(err);
        }
      });
  }

  toggle() {
    this.isSideBarActive = !this.isSideBarActive;
    this.$emit("sideBarActive", this.isSideBarActive);
    this.activeDropdowns = [];
  }

  activateDropdown(name: string): void {
    this.isSideBarActive = true;
    this.$emit("sideBarActive", this.isSideBarActive);
    const submenus: string[] = name.split(":");
    let dropdowns: string[] = this.activeDropdowns;
    const i = Number(submenus[0]);

    if (dropdowns[i]) {
      if (dropdowns[i] === submenus[1]) {
        if (submenus[0] === '1') {
          dropdowns = [];
        } else {
          dropdowns.splice(i);
        }
      } else {
        if (submenus[0] === '1') {
          dropdowns = [];
          dropdowns[i] = submenus[1];
        } else {
          dropdowns[i] = submenus[1];
        }
      }
    } else {
      dropdowns[i] = submenus[1];
    }

    this.activeDropdowns = [...dropdowns];
  }

  isDropdownActive(name: string): boolean {
    return !!this.activeDropdowns.filter((ad) => ad === name).length;
  }

  get nome() {
    const nome = usuarioModule.token?.name.split(" ");
    if (nome) {
      return nome.length > 1
        ? `${nome[0]} ${nome[1]}${
            nome[1].length < 3 && nome[2] ? ` ${nome[2]}` : ""
          }`
        : nome[0];
    } else {
      return "";
    }
  }

  get isAdministrador() {
    return usuarioStorage.authorities.includes(Authoritie.ADMINISTRADOR);
  }

  get isPeritoOrcamentoAuto() {
    return usuarioStorage.authorities.includes(Authoritie.PERITO_ORCAMENTO_AUTO_ONLINE);
  }

  get isAnalistaSaude() {
    return usuarioStorage.authorities.includes(Authoritie.ANALISTA_SAUDE);
  }

  get isContabilFinanceiro() {
    return usuarioStorage.authorities.includes(Authoritie.INTEGRACAO_CONTABIL);
  }

  get isAnalistaAssistencia24h() {
    return usuarioStorage.authorities.includes(Authoritie.ANALISTA_ASSISTENCIA_24H);
  }
}
